export default {
	
	validations: {
		required: "O valor é obrigatório.",
		email: "O valor não é um endereço de e-mail válido",
		minLength: "Este campo deve ter pelo menos ${min} caracteres",
		maxLength: "O comprimento máximo permitido é ${max}",
		minValue: "O valor mínimo permitido é ${min}",
		maxValue: "O valor máximo permitido é ${max}",
		numeric: "O valor deve ser numérico",
		ipAddress: "O valor não é um endereço IP válido",
		sameAs: "O valor deve ser igual ao valor ${otherName}",
	}
}